import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntity, updateEntity, createEntity, reset } from './user-custom.reducer';
import { IUserCustom } from 'app/shared/model/user-custom.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const UserCustomUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const users = useAppSelector(state => state.userManagement.users);
  /* const companies = useAppSelector(state => state.company.entities); */
  const userCustomEntity = useAppSelector(state => state.userCustom.entity);
  const loading = useAppSelector(state => state.userCustom.loading);
  const updating = useAppSelector(state => state.userCustom.updating);
  const updateSuccess = useAppSelector(state => state.userCustom.updateSuccess);

  const handleClose = () => {
    props.history.push('/user-custom' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getUsers({}));
    dispatch(getCompanies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.licenseValidity = convertDateTimeToServer(values.licenseValidity);

    const entity = {
      ...userCustomEntity,
      ...values,
      user: users.find(it => it.id.toString() === values.userId.toString()),
      /* company: companies.find(it => it.id.toString() === values.companyId.toString()), */
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userCustomEntity,
          licenseValidity: convertDateTimeFromServer(userCustomEntity.licenseValidity),
          userId: userCustomEntity?.user?.id,
          /* companyId: userCustomEntity?.company?.id, */
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.userCustom.home.createOrEditLabel" data-cy="UserCustomCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.userCustom.home.createOrEditLabel">Create or edit a UserCustom</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-custom-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="d-none"
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.userCustom.phone')}
                id="user-custom-phone"
                name="phone"
                data-cy="phone"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.userCustom.activated')}
                id="user-custom-activated"
                name="activated"
                data-cy="activated"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fleetSenseApp.userCustom.registry')}
                id="user-custom-registry"
                name="registry"
                data-cy="registry"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.userCustom.identificationCode')}
                id="user-custom-identificationCode"
                name="identificationCode"
                data-cy="identificationCode"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.userCustom.licenseValidity')}
                id="user-custom-licenseValidity"
                name="licenseValidity"
                data-cy="licenseValidity"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="user-custom-user"
                name="userId"
                data-cy="user"
                label={translate('fleetSenseApp.userCustom.user')}
                type="select"
              >
                {isNew ? <option value="" key="0" /> : null}
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              {/* <ValidatedField
                id="user-custom-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.userCustom.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField> */}
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-custom" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserCustomUpdate;
